import React from 'react';
import { i18n } from 'utils/i18n';
import { sanitize } from 'utils/validation';
import Modal from 'components/Modal';
import MODAL, { MODAL_THEMES } from 'constants/modals';

const ProgressBarCIDModal = () => (
  <Modal
    modalKey={MODAL.CID_TERMS_AND_CONDITIONS_MODAL}
    header={i18n('progress_bar_cid_terms_conditions')}
    theme={MODAL_THEMES.WHITE}
  >
    {({ termsConditions }) => (
      <div id={`${MODAL.CID_TERMS_AND_CONDITIONS_MODAL}_desc`} dangerouslySetInnerHTML={sanitize(termsConditions)} />
    )}
  </Modal>
);

export default ProgressBarCIDModal;
